<div class="news">
  <section-header [data]="dataHeader"></section-header>
  <div class="card-container d-flex flex-row col-md-12 col-sm-12 justify-content-center">
    <a target="_blank" *ngFor="let card of cardsData" [routerLink]="['/noticias', card.id]">
      <news-card class="no-margin" [cardInfo]="card"></news-card>
    </a>
  </div>
  <div class="news-button d-flex justify-content-end">
    <a [routerLink]="['/noticias']" class="btn">Ver más noticias</a>
  </div>
</div>
<div class="news">
  <section-header [data]="dataHeaderWeatherCondition"></section-header>
  <div class="row mt-4 mb-4 ml-4 mr-4">
    <div *ngFor="let weather of dataGetWeather"
      class="card-container d-flex flex-row col-md-4 col-sm-4 justify-content-center mt-3">
      <app-weather-condition [name]="weather.name" [iat]="weather.iat" [ion]="weather.ion" [appid]="weather.appid"
        [description]="weather.description"></app-weather-condition>
    </div>
  </div>
</div>
<div class="news">
  <section-header [data]="dataHeaderSocialNetwork"></section-header>
  <div class="contenedor">
    <!-- Facebook -->
    <div class="caja" *ngIf="facebookEnabled?.activo">
      <iframe name="f16afff68e86433b5" width="1000px" height="1000px" data-testid="fb:page Facebook Social Plugin"
        title="fb:page Facebook Social Plugin" allowfullscreen="true" scrolling="no" allow="encrypted-media"
        src="https://www.facebook.com/v2.5/plugins/page.php?adapt_container_width=true&amp;app_id=425960334187885&amp;channel=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Dfc029e3bbcdfd8220%26domain%3Dwww.autovia.com.co%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fwww.autovia.com.co%252Ffddd32dc8cd81e28f%26relation%3Dparent.parent&amp;container_width=370&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2FAutovia-Neiva-Girardot-SAS-972422292852864%2F&amp;locale=es_LA&amp;sdk=joey&amp;show_facepile=true&amp;small_header=false&amp;tabs=timeline"
        style="border: none; visibility: visible; width: 340px; height: 500px;"></iframe>
    </div>
    <!-- Instagram -->
    <div class="caja" *ngIf="instagramEnabled?.activo"><app-instagram-feed></app-instagram-feed></div>
    <!-- Twitter -->
    <div class="caja" *ngIf="twitterEnabled?.activo"><a class="twitter-timeline" data-width="400" data-height="540"
        href="https://twitter.com/AutoviaNG?ref_src=twsrc%5Etfw" data-chrome="noborders nofooter transparent"
        data-lang="es">Tweets by
        AutoviaNG</a>
      <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
    </div>
  </div>
  <div class="partners-container d-flex flex-wrap justify-content-around mt-5">
    <image-link *ngFor="let logo of partners" [imgInfo]="logo"></image-link>
  </div>
</div>